import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader,
  ContainerTable
} from '../../components/layout/main/mainStyles';
import Strings from '../../i18n';
import { ConnectivityStatus } from '../../templates/applications/connectivityStatus/connectivityStatus';
import { useConnectivityStatusByLocationMutation } from '../../services/device/deviceService';

export const ConnectivityStatusView = () => {
  const { locationId } = useParams();
  const [connectivityStatusByLocation, { isSuccess, data }] =
    useConnectivityStatusByLocationMutation();
  useEffect(() => {
    if (locationId) {
      connectivityStatusByLocation(+locationId);
    }
  }, [locationId]);
  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-1 col-sm-4 text-left" />
            <div className="col-6 col-sm-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.connectivityStatus.connectivityStatus}
              </StyledTitleHeader>
            </div>
            <div className="col-5 col-sm-4 text-right" />
          </div>
        </StyledHeaderContainer>
      </Header>
      <ContainerTable component="main">
        <ConnectivityStatus data={data || []} />
      </ContainerTable>
    </>
  );
};
